module.exports = __webpack_public_path__ + "static/img/year.36f8d8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/year.png
// module id = BdlY
// module chunks = 2